import { ScrollView, Text } from "react-native";
import { View } from "ui/atoms/view";
import { Icon } from "ui/gluestack/icon";

interface Props {
  children: React.ReactNode;
  title: string;
  total?: string;
  titleClassNames?: string;
  icon?: React.ElementType;
  strokeColor?: string;
}

export function SectionCard({
  children,
  title,
  total,
  titleClassNames,
  icon,
  strokeColor,
}: Props) {
  return (
    <View className="bg-white rounded-2xl px-4 py-6 h-[410px]">
      <View className="flex-row justify-between  pb-4 items-center">
        <View className="flex-row items-center gap-x-2">
          <Text className={`text-lg font-medium ${titleClassNames}`}>
            {title}
          </Text>
          <Icon as={icon} className={`${strokeColor} w-5 h-5`} />
        </View>
        <Text className="text-sm text-typography-600">{total}</Text>
      </View>

      <ScrollView>
        <View className={`${strokeColor} w-full`}>{children}</View>
      </ScrollView>
    </View>
  );
}
